import * as React from "react";
const GlobalSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.03}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="M28 16.625A11.375 11.375 0 1 0 39.375 28 11.387 11.387 0 0 0 28 16.625ZM37.625 28a9.582 9.582 0 0 1-.7 3.603l-4.89-3.007a1.74 1.74 0 0 0-.682-.244l-2.495-.337a1.763 1.763 0 0 0-1.75.86h-.954l-.416-.86a1.738 1.738 0 0 0-1.203-.948l-.875-.19.855-1.502h1.828c.296 0 .587-.076.845-.219l1.34-.74c.118-.065.228-.143.328-.233L31.8 21.52a1.742 1.742 0 0 0 .356-2.15l-.04-.072A9.637 9.637 0 0 1 37.626 28Zm-7.95-9.478.95 1.701-2.943 2.663-1.339.739h-1.828a1.75 1.75 0 0 0-1.518.875l-.955 1.666-1.11-2.958 1.197-2.83a9.612 9.612 0 0 1 7.547-1.859l-.002.003ZM18.374 28a9.572 9.572 0 0 1 .934-4.134l1.24 3.31a1.75 1.75 0 0 0 1.271 1.094l2.344.504.417.867a1.76 1.76 0 0 0 1.575.984h.162l-.791 1.775a1.75 1.75 0 0 0 .313 1.9l.015.015L28 36.525l-.212 1.093A9.637 9.637 0 0 1 18.375 28Zm11.22 9.492.123-.636a1.76 1.76 0 0 0-.453-1.535l-2.14-2.209 1.498-3.362 2.496.337 5.001 3.076a9.644 9.644 0 0 1-6.525 4.329Z"
    />
  </svg>
);
export default GlobalSVG;
